/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { ComboboxOption } from '@headlessui/react'
import clsx from 'clsx'
import { CheckIcon } from '@heroicons/react/24/solid'

interface LeadTagsOptionsListProps {
    query: string
    existingTags: string[]
    filteredTags: string[]
    selectedTags: string[]
    translate: (value: string) => string
}

const LeadTagsOptionsList = (props: LeadTagsOptionsListProps) => {
    return (
        <div className="LeadTagsOptionsList">
            {props.filteredTags.map((tag) => (
                <ComboboxOption
                    key={tag}
                    value={tag}
                    className={({ active }) =>
                        clsx(
                            'relative cursor-default select-none py-2 pl-3 pr-9',
                            active
                                ? 'bg-indigo-600 text-white'
                                : 'text-gray-900 dark:text-gray-100'
                        )
                    }
                >
                    {({ selected, active }) => (
                        <>
                            <span
                                className={clsx(
                                    'block truncate',
                                    selected ? 'font-semibold' : 'font-normal'
                                )}
                            >
                                {tag}
                            </span>
                            {props.selectedTags.includes(tag) && (
                                <span
                                    className={clsx(
                                        'absolute inset-y-0 right-0 flex items-center pr-4',
                                        active
                                            ? 'text-white'
                                            : 'text-indigo-600'
                                    )}
                                >
                                    <CheckIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    />
                                </span>
                            )}
                        </>
                    )}
                </ComboboxOption>
            ))}
        </div>
    )
}

export default LeadTagsOptionsList
